export default "__VITE_ASSET__DZ3Lu43u__"